/**
 * Centralized backend URL builder.
 * Every edge-function call in the app should use these helpers
 * so the host is defined in exactly one place.
 */

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;

if (import.meta.env.DEV) {
  console.log('[api] VITE_SUPABASE_URL =', SUPABASE_URL);
  console.log('[api] VITE_SUPABASE_PROJECT_ID =', import.meta.env.VITE_SUPABASE_PROJECT_ID);
}

/** Build a full URL for a Supabase Edge Function */
export const edgeFn = (fnName: string, queryString?: string): string => {
  const base = `${SUPABASE_URL}/functions/v1/${fnName}`;
  return queryString ? `${base}?${queryString}` : base;
};

/** Shorthand for projects-api calls */
export const projectsApi = (params: string): string =>
  edgeFn('projects-api', params);

/** Shorthand for other common edge functions */
export const authApi = (): string => edgeFn('auth-system');
export const adminApi = (): string => edgeFn('admin-api');
export const linkedinApi = (): string => edgeFn('linkedin-scraper');
export const messageApi = (): string => edgeFn('message-generator');
export const messageChatApi = (): string => edgeFn('message-chat');
export const documentsApi = (): string => edgeFn('documents-api');
export const ttsApi = (): string => edgeFn('elevenlabs-tts');
export const ttsCleanupApi = (): string => edgeFn('tts-cleanup');
export const appAuthApi = (): string => edgeFn('app-auth');
export const messageHistoryApi = (): string => edgeFn('message-history');
